// client/src/context/UserPreferencesContext.js
import React, { createContext, useContext } from 'react';
// Importiere den Hook, der die Logik enthält
import { useUserPreferences as useUserPreferencesHook } from '../hooks/useUserPreferences';

// Erstelle den Context. Der Startwert ist null, da der Provider die Werte liefert.
const UserPreferencesContext = createContext(null);

// Provider-Komponente
export const UserPreferencesProvider = ({ children }) => {
  // Rufe den Hook *hier* auf. Alle States und Funktionen leben in dieser Instanz.
  const preferences = useUserPreferencesHook();

  // Stelle das gesamte 'preferences'-Objekt (das alle States und Funktionen enthält)
  // über den Context Provider für alle Kind-Komponenten bereit.
  return (
    <UserPreferencesContext.Provider value={preferences}>
      {children}
    </UserPreferencesContext.Provider>
  );
};

// Eigener Hook zum einfachen Konsumieren des Contexts in anderen Komponenten
export const useUserPreferences = () => {
  const context = useContext(UserPreferencesContext);
  // Stelle sicher, dass der Hook innerhalb des Providers verwendet wird
  if (context === null) {
    throw new Error('useUserPreferences must be used within a UserPreferencesProvider');
  }
  // Gib das gesamte 'preferences'-Objekt zurück, das vom Provider bereitgestellt wird
  return context;
};

// Exportiere den Context selbst nicht standardmäßig, da der Hook die bevorzugte Methode ist.
// export default UserPreferencesContext;
